import { Card } from './Card';

/**
 * Placeholder blocks that hold the same space as the content they stand in
 * for, so arriving data doesn't shift the layout the way a centred spinner
 * followed by a full render does.
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div
      className={`relative overflow-hidden rounded bg-gray-200 dark:bg-gray-700 ${className}`}
    >
      <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/40 dark:via-white/10 to-transparent" />
    </div>
  );
}

/** Matches ServiceCard's geometry: header, uptime strip, metric row. */
export function ServiceCardSkeleton() {
  return (
    <Card className="p-4">
      <div className="flex items-start justify-between mb-3 gap-3">
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="h-4 w-2/5" />
          <Skeleton className="h-3 w-4/5" />
        </div>
        <Skeleton className="h-4 w-20 shrink-0" />
      </div>
      <Skeleton className="h-6 w-full" />
      <div className="flex items-center justify-between mt-3">
        <Skeleton className="h-3 w-20" />
        <Skeleton className="h-3 w-12" />
        <Skeleton className="h-3 w-16" />
      </div>
    </Card>
  );
}

export function DashboardSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="space-y-6" aria-busy="true" aria-live="polite" aria-label="Loading services">
      <Skeleton className="h-[4.5rem] w-full" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: count }).map((_, i) => <ServiceCardSkeleton key={i} />)}
      </div>
    </div>
  );
}

export function DetailSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-live="polite" aria-label="Loading service">
      <Skeleton className="h-8 w-1/3" />
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Card key={i} className="p-4 space-y-2">
            <Skeleton className="h-3 w-2/3" />
            <Skeleton className="h-7 w-1/2" />
          </Card>
        ))}
      </div>
      <Skeleton className="h-64 w-full" />
    </div>
  );
}
